module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetMedium@2x.b43885b.jpg";